import {
	CreateUpdateSensorGroupFormValues,
	ListSensorGroupsParams,
	PaginatedSensorGroupPairs,
	PaginatedSensorGroups,
	SensorGroupConfig,
} from '@Types/sensorGroup.types';

import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import { ConfiguredSensor } from '@Types';

// SensorGroup

export const clearSensorGroups = createAction(
	addNamespace('sensorGroup/sensorGroup/clear'),
);

export const getSensorGroups = createAction<ListSensorGroupsParams>(
	addNamespace('sensorGroup/sensorGroup/get/all'),
);
export const getSensorGroupsResolved = createAction<PaginatedSensorGroups>(
	addNamespace('sensorGroup/sensorGroup/get/all/resolved'),
);
export const getSensorGroupsRejected = createAction(
	addNamespace('sensorGroup/sensorGroup/get/all/rejected'),
);

export const getSingleSensorGroupById = createAction<string>(
	addNamespace('sensorGroup/sensorGroup/get/single'),
);
export const getSingleSensorGroupByIdResolved = createAction<SensorGroupConfig>(
	addNamespace('sensorGroup/sensorGroup/get/single/resolved'),
);
export const getSingleSensorGroupByIdRejected = createAction(
	addNamespace('sensorGroup/sensorGroup/get/single/rejected'),
);

export const upsertSensorGroupConfig =
	createAction<CreateUpdateSensorGroupFormValues>(
		addNamespace('sensorGroup/sensorGroup/upsert'),
	);
export const upsertSensorGroupConfigResolved = createAction(
	addNamespace('sensorGroup/sensorGroup/upsert/resolved'),
);
export const upsertSensorGroupConfigRejected = createAction(
	addNamespace('sensorGroup/sensorGroup/upsert/rejected'),
);

export const deleteSensorGroup = createAction<string>(
	addNamespace('sensorGroup/sensorGroup/delete'),
);
export const deleteSensorGroupResolved = createAction(
	addNamespace('sensorGroup/sensorGroup/delete/resolved'),
);
export const deleteSensorGroupRejected = createAction(
	addNamespace('sensorGroup/sensorGroup/delete/rejected'),
);

// sensorGroupPairs

export const clearSensorGroupPairs = createAction(
	addNamespace('sensorGroup/sensorGroupPairs/clear'),
);

export const getSensorGroupPairs = createAction<string>(
	addNamespace('sensorGroup/sensorGroupPairs/get'),
);
export const getSensorGroupPairsResolved =
	createAction<PaginatedSensorGroupPairs>(
		addNamespace('sensorGroup/sensorGroupPairs/get/resolved'),
	);
export const getSensorGroupPairsRejected = createAction(
	addNamespace('sensorGroup/sensorGroupPairs/get/rejected'),
);

export const getSensorGroupMap = createAction<ListSensorGroupsParams>(
	addNamespace('sensorGroup/sensorGroupMap/get'),
);
export const clearSensorGroupMap = createAction(
	addNamespace('sensorGroup/sensorGroupMap/clear'),
);
export const getSensorGroupMapResolved = createAction<{
	[key: string]: SensorGroupConfig;
}>(addNamespace('sensorGroup/sensorGroupMap/get/resolved'));
export const getSensorGroupMapRejected = createAction(
	addNamespace('sensorGroup/sensorGroupMap/get/rejected'),
);
export const getSensors = createAction<{
	type: 'virtual' | 'physical' | undefined;
	sensorType: string;
}>(addNamespace('sensorGroup/getSensors'));
export const getSensorsResolved = createAction<ConfiguredSensor[]>(
	addNamespace('sensorGroup/getSensorsResolved'),
);
export const getSensorsRejected = createAction(
	addNamespace('sensorGroup/getSensorsRejected'),
);
